import LogoutIcon from '@mui/icons-material/Logout'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import LoginIcon from '@mui/icons-material/Login'

export const MenuIconByType = {
    logout: <LogoutIcon />,
    myAccount: <AccountBoxIcon />,
    login: <LoginIcon />,
}
